import { render, staticRenderFns } from "./ModalVideoPlayer.vue?vue&type=template&id=5d32ab89&scoped=true&"
import script from "./ModalVideoPlayer.vue?vue&type=script&lang=js&"
export * from "./ModalVideoPlayer.vue?vue&type=script&lang=js&"
import style0 from "./ModalVideoPlayer.vue?vue&type=style&index=0&id=5d32ab89&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d32ab89",
  null
  
)

export default component.exports